import styled from "styled-components";
import Select from "react-select";
import get from "lodash.get";

export const SelectWrapper = styled.div<any>`
  .react-select__control {
    background-color: ${({ theme, error }) =>
      error ? theme.white.main : theme.form.light} !important;
    border: 1px solid
      ${({ theme, error }) => (error ? theme.error.main : theme.form.light)} !important;
  }
`;

export const ReactSelect = styled(Select)`
  .react-select__control {
    border-radius: 8px;
    padding: 6px 8px;
    min-width: 156px;
    &:hover {
      cursor: pointer;
    }
  }
  .react-select__value-container {
    font-size: 14px;
    .react-select__single-value {
      font-weight: 600;
      color: ${({ theme, isDisabled }) =>
        isDisabled ? theme.secondary.main : theme.secondary.dark};
    }
    .react-select__placeholder {
      color: #999;
    }
    .react-select__multi-value {
      background-color: ${({ theme }) => theme.primary.dark};
      border-radius: 16px;
      display: flex;
      align-items: center;
      padding-right: 3px;

      .react-select__multi-value__label {
        color: ${({ theme }) => theme.white.main};
      }

      .react-select__multi-value__remove {
        color: ${({ theme }) => theme.primary.dark};
        background-color: ${({ theme }) => theme.white.main};
        padding: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }
    }
  }

  .react-select__indicator-separator {
    display: none;
  }

  & #react-select-3-listbox {
    background: ${({ theme }) => theme.white.main}!important;
    outline: none;
    box-shadow: none;

    div {
      div {
        background: ${({ theme }) => theme.white.main};
      }
    }
  }

  .react-select__indicator.react-select__dropdown-indicator,
  .react-select__indicator.react-select__clear-indicator {
    font-size: 10px;
    font-weight: 100 !important;
    transform: scale(0.9);
    svg {
      transition: all, 0.2s !important;
      path {
        fill: ${({ theme }) => theme.secondary.main} !important;
      }
    }
  }

  .react-select__indicator.react-select__clear-indicator {
    &:hover {
      cursor: pointer;
    }
  }

  .react-select__control.react-select__control--is-focused.react-select__control--menu-is-open {
    .react-select__indicator.react-select__dropdown-indicator {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  .react-select__menu {
    box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0 !important;
    margin: 3px 0;
    padding: 1rem 0;
    border-radius: 0;
    border: 1.5px solid ${({ theme }) => theme.white.dark} !important;
    outline: none;
    border-radius: 5px;
    z-index: 1000001;
    border: none !important;
    .react-select__menu-list {
      padding: 0;
      .react-select__option {
        position: relative;
        color: ${({ theme }) => theme.secondary.dark};
        transition: all 0.25s;
        font-size: 14px;
        padding: 1rem;
      }

      .react-select__option.react-select__option--is-focused {
        background-color: ${({ theme }) => get(theme, "white.main")};
      }

      .react-select__option {
        &:hover {
          background-color: ${({ theme }) => get(theme, "secondary.light")};
          color: ${({ theme }) => get(theme, "primary.dark")};
          cursor: pointer;
        }
      }

      .react-select__option.react-select__option--is-selected {
        background-color: ${({ theme }) => get(theme, "secondary.light")};
        color: ${({ theme }) => get(theme, "primary.dark")};
      }
    }
  }

  & > div {
    border: 1.5px solid ${({ theme }) => theme.white.dark} !important;
    box-shadow: none !important;
    border-radius: 12px;
    outline: none;
    color: ${({ theme }) => theme.secondary.medium};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: -0.02em;
    box-sizing: border-box;
    padding: 3px 3px;
  }
`;

export const SelectLabel = styled.label`
  color: ${({ theme }) => theme.info.dark};
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: -0.02em;
  margin-bottom: 6px;
  width: 100%;
  text-align: start;
  display: flex;
  gap: 20px;
  align-items: center;

  svg {
    cursor: pointer;
    &:hover {
      path {
        fill: #019ef7;
        transition: all 0.3s ease;
      }
    }
  }
`;
